module.exports = __webpack_public_path__ + "static/media/mobile_menu.710b4061.svg";